import Highcharts, { color } from "highcharts";
import { useEffect, useState } from "react";
import { api } from "../..";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter-icon.svg";
import drilldown from "highcharts/modules/drilldown";
import "./facilitiesVacsGraph.css";

const FacilitiesVacsGraph = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [drillDownData, setDrilldownData] = useState();
  const [status, setStatus] = useState("");

  drilldown(Highcharts);

  const getFilteredData = (e) => {
    e.preventDefault();
    api
      .get(
        `/api/graph_vac?status=${status}&start_date=${convertDate(
          startDate
        )}&end_date=${convertDate(endDate)}`
      )
      .then((res) => {
        setDrilldownData(res.data);
      });
  };

  function convertDate(dateString) {
    const [year, month, day] = dateString.split("-");

    return `${day}-${month}-${year}`;
  }

  useEffect(() => {
    api
      .get(
        `/api/graph_vac?status=pending&start_date=10-01-2000&end_date=01-01-2050`
      )
      .then((res) => {
        setDrilldownData(res.data);
      });
  }, []);

  useEffect(() => {
    if (drillDownData) {
      const seriesData = drillDownData?.series.map((item) => ({
        name: item.name,
        y: item.y,
        drilldown: item.drilldown,
        color: "rgb(255, 205, 86)",
      }));

      const drilldownSeries = drillDownData?.drilldown?.series.map((item) => ({
        name: item.name,
        id: item.id,
        data: item.data,
        // color: "rgb(255, 205, 86)",
      }));

      const options = {
        chart: {
          type: "column",
        },
        title: {
          //   text: "Timeframe and Vaccination Status Data Per Facility",
          text: drillDownData?.title?.text,
        },
        xAxis: {
          type: "category",
        },

        legend: {
          enabled: false,
        },

        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
        },

        series: [
          {
            name: "Facilities",
            colorByPoint: true,
            data: seriesData,
          },
        ],
        drilldown: {
          series: drilldownSeries,
        },
      };

      // Create the chart
      Highcharts.chart("chart-container-2", options);
    }
  }, [drillDownData]);

  return (
    <div className="facilities__filter__graph__container">
      <div className="facilities__filter__graph__filters">
        <form
          className="filter__param-span filter__param-span-2"
          style={{ zIndex: "30" }}
          onSubmit={getFilteredData}
        >
          <div className="input__span-onn">
            <label htmlFor="date" className="filter__param-label">
              Start Date
            </label>
            <input
              type="date"
              id="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="filter__param-input filter__param-input-2"
            />
          </div>
          <div className="input__span-onn">
            <label htmlFor="date" className="filter__param-label">
              End Date
            </label>
            <input
              type="date"
              id="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="filter__param-input filter__param-input-2"
            />
          </div>
          <div className="input__span-onn">
            <label htmlFor="date" className="filter__param-label">
              Status
            </label>
            <select
              className="filter__param-input filter__param-input-2"
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="pending">Pending</option>
              <option value="missed">Missed</option>
              <option value="completed">Taken</option>
            </select>
          </div>
          <button
            className="filter__CTA filter__CTA-2"
            type="submit"
            // onClick={() => getFilteredData()}
            disabled={!startDate || !endDate || !status ? true : false}
          >
            Filter
            <FilterIcon style={{ marginLeft: "1rem" }} />
          </button>
        </form>
        {/* <span className="filter__CTA-span">
        </span> */}
      </div>
      {drillDownData && (
        <div
          id="chart-container-2"
          style={{ height: "400px", width: "100%", marginTop: "2rem" }}
        ></div>
      )}
    </div>
  );
};

export default FacilitiesVacsGraph;
